import { FlattenMaps, Require_id } from "mongoose";
import { DocumentType } from "@typegoose/typegoose";

const ExistingUIDs = {
    id: 0,
};
export function generateUID(prefix = "id") {
    if (!ExistingUIDs[prefix]) {
        ExistingUIDs[prefix] = 0;
    }
    ExistingUIDs[prefix]++;
    return `${prefix}${ExistingUIDs[prefix]}`;
}

// Document type definitions - single source of truth for the entire monorepo
export type LeanDoc<T> = Require_id<FlattenMaps<T>> & { $locals?: never };
export type HydratedDoc<T> = DocumentType<T>;
export type LeanOrHydratedDoc<T> = LeanDoc<T> | HydratedDoc<T>;

function isMongoDocument<T>(input: unknown): input is DocumentType<T> {
    return input != null && typeof input === "object" && "toObject" in input && typeof input.toObject === "function";
}

export function potentialMongoInstanceToPlainObject<InputType>(
    input: InputType | LeanOrHydratedDoc<InputType>,
): InputType {
    if (isMongoDocument<InputType>(input)) {
        return input.toObject({ flattenMaps: true }) as InputType;
    }
    return input as InputType;
}
